module.exports = __webpack_public_path__ + "static/media/arrowRightInput.a610c093.svg";